import React from 'react';
import { motion } from 'framer-motion';
export function ResultsSection() {
  const results = ['mayor control eyaculatorio', 'erecciones más estables', 'menos ansiedad', 'más confianza', 'más presencia', 'mejor desempeño'];
  return <section className="relative w-full bg-black py-8 md:py-12 overflow-hidden" data-id="element-417">
      <div className="absolute inset-0 z-0" data-id="element-418">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-red-800/15 blur-[140px]" data-id="element-419" />
      </div>

      <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-[#0a0a0a] to-transparent z-10" data-id="element-420" />
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-[#0a0a0a] to-transparent z-10" data-id="element-421" />

      <div className="relative z-20 max-w-5xl mx-auto px-6" data-id="element-422">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-423">
          <h2 className="font-display text-3xl md:text-5xl uppercase mb-3 text-center text-white drop-shadow-[0_0_20px_rgba(220,38,38,0.3)]" data-id="element-424">
            Lo que vas a sentir
          </h2>
          <p className="text-center text-sm md:text-base text-gray-500 uppercase tracking-widest mb-8" data-id="element-425">
            Resultados esperados
          </p>

          {/* Compact 3-col grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-426">
            {results.map((result, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06,
            duration: 0.4
          }} className="bg-[#0a0a0a]/80 backdrop-blur-sm border border-red-900/40 px-4 py-3.5 rounded-lg flex items-center gap-3 shadow-[0_0_15px_rgba(220,38,38,0.05)]" data-id="element-427">
                <span className="text-red-500 text-lg flex-shrink-0 drop-shadow-[0_0_6px_rgba(220,38,38,0.5)]" data-id="element-428">
                  ✔
                </span>
                <span className="text-sm md:text-base text-white font-medium capitalize" data-id="element-429">
                  {result}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}